import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { NavigationService } from '../../../services/navigation.service';
import { NavigationItem as NavItem, NavigationAction, NavigationDropdown, NavigationLink } from '../../../models/navigation-item.interface';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NxIconService } from '../../../../../core/services/icon.service';
import { NavBadgeService } from '../../../services/nav-badge.service';

@Component({
  selector: 'app-navigation-item',
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatBadgeModule,
    MatMenuModule,
    MatButtonModule,
  ],
  templateUrl: './navigation-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationItem {
  private navigationService = inject(NavigationService);
  private readonly _iconService = inject(NxIconService);
  private readonly navBadgeService = inject(NavBadgeService);

  item = input.required<NavItem>();
  actionTriggered = output<string>();

  isLink(item: NavItem): item is NavigationLink {
    return this.navigationService.isLink(item);
  }

  isDropdown(item: NavItem): item is NavigationDropdown {
    return this.navigationService.isDropdown(item);
  }

  isAction(item: NavItem): item is NavigationAction {
    return this.navigationService.isAction(item);
  }

  isHighlighted(item: NavItem): boolean {
    return this.isLink(item) && !!item.highlighted;
  }

  /** Resolve o valor do badge: dinamico via `NavBadgeService` quando `badgeKey` estiver definido, senao o `value` estatico. */
  badgeValue(item: NavigationLink): string {
    const badge = item.badge;
    if (!badge) return '';
    if (badge.badgeKey) return String(this.navBadgeService.count(badge.badgeKey)());
    return badge.value;
  }

  badgeHidden(item: NavigationLink): boolean {
    return !item.badge || this.badgeValue(item) === '0';
  }

  onAction(): void {
    const navItem = this.item();
    if (this.isAction(navItem)) {
      this.actionTriggered.emit(navItem.action);
    }
  }
}
